// extracted by mini-css-extract-plugin
module.exports = {"root":"SkuWhyGeneralMedicine_root__EgYdX"};